import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Table } from "../../../Table/Table";
import Loading from "../../../Loadings/LoadingTable";
import { MdDeleteForever } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { MdSubtitles } from "react-icons/md";
import Button from "../../../Button/Button";
import EditSeo from "../../../Dialog/contentUnit/EditSeo";
import { useGetProductList1 } from "../../../../hooks/useContent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  ContentUnitModal,
  RefreshTableLevel1,
} from "../../../../shared/content-unit";
import { RenderTooltip } from "../../../Tooltip/Tooltip";

function LevelFirstTable() {
  const refresh = useRecoilValue(RefreshTableLevel1);

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [showSeo, setShowSeo] = useState(false);
  const [currentSeo, setCurrentSeo] = useState({});

  const { data, isLoading, refetch } = useGetProductList1(search);

  const [moduals, setModuals] = useRecoilState(ContentUnitModal);
  let categoryList = data?.data?.categories;
  let pageCount = data?.data?.categories?.length;

  useEffect(() => {
    refetch(search);
    categoryList = [];
  }, [refresh]);

  const headerTitle = [
    "#",
    "نام دسته بندی",
    "نام دسته بندی انگلیسی",
    "نام دسته بندی عربی",
    "لیبل برای کد محصول",
    "رنگی",
    "مشکی",
    "عملیات",
  ];

  const handleDeleteCatergory = (category) => {
    setModuals({
      ...moduals,
      deleteLevel1: { value: category, isShow: true },
    });
  };

  const handleUpdateCategory = (item) => {
    setModuals({ ...moduals, updateLevel1: { value: item, isShow: true } });
  };

  const handleUpdateSEO = (item) => {
    setShowSeo(true);
    setCurrentSeo(item);
  };

  // handle next page
  const handleNext = () => {
    if (pageNumber < pageCount) setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (pageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  const baseURlImg = "https://apicampozit.mahanskinclinic.com/thumbnail/Sliders/";

  let i = 0;

  const items = data ? (
    data?.data?.categories?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NameCategories ? item?.NameCategories : ""}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NameEnglishCategories ? item?.NameEnglishCategories : ""}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NameLanguageCategories ? item?.NameLanguageCategories : ""}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.LabelForCodeProduct ? item?.LabelForCodeProduct : ""}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <img
                className="slider-image-table"
                src={`${item?.AikenCategoriesSvgLight}`}
                alt={"عکس رنگی"}
              />
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <img
                className="slider-image-table"
                src={`${item?.AikenCategoriesSvgDark}`}
                alt={"عکس مشکی"}
              />
            </span>
          </td>
          <td>
            <ButtonContainer>
              <RenderTooltip title={"حذف دسته بندی"}>
                <Button
                  size="12px"
                  bgColor="#C82333"
                  small="38px"
                  color="#fff"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onclick={(e) => {
                    handleDeleteCatergory(item);
                  }}
                >
                  <MdDeleteForever size={25} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title={"ویرایش دسته بندی"}>
                <Button
                  size="12px"
                  bgColor="#0D6EFD"
                  small="40px"
                  color="#fff"
                  onclick={(e) => {
                    handleUpdateCategory(item);
                  }}
                >
                  <FiEdit size={20} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title={"ویرایش  سِو"}>
                <Button
                  size="12px"
                  bgColor="#575b92"
                  small="40px"
                  color="#fff"
                  ط
                  onclick={(e) => {
                    handleUpdateSEO(item);
                  }}
                >
                  <MdSubtitles size={20} />
                </Button>
              </RenderTooltip>
            </ButtonContainer>
          </td>
        </tr>
      );
    })
  ) : (
    <Loading />
  );

  return (
    <CategoryTableStyle>
      <Table
        headerTitle={headerTitle}
        title={`  دسته بندی بندی هایی که تا کنون برای سطح اول ثبت کرده اید  : ${
          pageCount ? pageCount : ""
        }`}
        items={items}
        setSearch={setSearch}
      />
      <EditSeo
        show={showSeo}
        IdRefrenceSeo={currentSeo?.IdCategories}
        handleClose={() => {
          setShowSeo(false);
        }}
        locationSeo="CategoryLevel1"
        item={currentSeo}
      />
    </CategoryTableStyle>
  );
}

const CategoryTableStyle = styled.div`
  width: 100%;
  margin-top: 1rem;

  .slider-image-table {
    width: 90px;
    height: 60px;
    object-fit: contain;
    border-radius: 0.5rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  column-gap: 1rem;
  row-gap: 1rem;
  flex-wrap: wrap;
`;

export default LevelFirstTable;
